import script from "./GearBoxesView.vue?vue&type=script&setup=true&lang=js"
export * from "./GearBoxesView.vue?vue&type=script&setup=true&lang=js"

import "./GearBoxesView.vue?vue&type=style&index=0&id=37bf45cd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37bf45cd"]])

export default __exports__